import { Plugin } from 'vue'

import moment from 'moment'
import { useLegalEntityStore } from '@/store/LegalEntityStore'
import { useSettingsStore } from '@/store/SettingsStore'
import { format } from 'date-fns'
import { privileges } from '@/services/privileges'
import { selectedLang } from '@/services/language'
import { itemsPerPageOptions } from '@/utils/environment'

export function getBeta(): boolean {
  const settingsStore = useSettingsStore()
  return settingsStore.getBeta
}

export function legacyEnabled(): boolean {
  // Legacy-Access only with Agate-Token and without Domain-Switch
  const legalEntityStore = useLegalEntityStore()
  const settingsStore = useSettingsStore()
  return settingsStore.getOIDC === 'agate' && !(legalEntityStore.getSelectedPersonId != legalEntityStore.getOriginLegalEntityId)
}

export const Globals: Plugin = {
  install(app: any) {
    app.config.globalProperties.$upLang = selectedLang.value.upLang
    app.config.globalProperties.$nameKey = selectedLang.value.nameKey
    app.config.globalProperties.$getBeta = getBeta
    app.config.globalProperties.$getDebug = () => {
      const settingsStore = useSettingsStore()
      return settingsStore.getDebug
    }
    app.config.globalProperties.$itemsPerPage = 50
    app.config.globalProperties.$itemsPerPageOptions = itemsPerPageOptions
    app.config.globalProperties.$moment = moment
    app.config.globalProperties.$format = format
    app.config.globalProperties.$privileges = privileges
    app.config.globalProperties.$legacyEnabled = legacyEnabled

    app.config.globalProperties.$goNext = (elem: any) => {
      const currentIndex = Array.from(elem.form.elements).indexOf(elem)
      const activeElems: any[] = Array.from(elem.form.elements)
        .filter((el: any, index: number) => index > currentIndex)
        .filter((el: any) => !el.disabled)
      if (activeElems.length) {
        activeElems[0].focus()
      } else {
        elem.form.elements.item(0).focus()
      }
    }
  }
}
